import { Component } from '@angular/core';
import { SubmissionService } from '../services/submission.service';

@Component({
    selector: 'ell-privacy',
    standalone: true,
    imports: [],
    templateUrl: './privacy.component.html',
    styleUrl: './privacy.component.scss'
})
export class PrivacyComponent {
    constructor(private submissionService: SubmissionService) {
    }

    encryptionActivated() {
        return this.submissionService.encryptionActivated();
    }
}
